import axios from '../modules/marketplace/axios-marketplace';

const get = id => axios.get(`/configuracoes-vendas/${id}`);

export default {
  get,
};
